import { Component } from "react";
import { Switch } from "react-router";
import AuthorizeRoute from "../components/api-authorization/AuthorizeRoute";
import { TrainOverviewPage } from "../pages/train-admin-page/OverviewPage";
import { TrainReportsPage } from "../pages/train-admin-page/ReportsPage";
import { TrainSettingsPage } from "../pages/train-admin-page/SettingsPage";
import { AccountManagementPage } from "../pages/train-admin-page/account-management-page/AccountManagementPage";
import { TrainAdminLayout } from "./TrainAdminLayout";
import { TrainLayout } from "./TrainLayout";
import { RouteWithLayout } from "./RouteWithLayout";
import { UserNotFoundInEvf } from "../pages/UserNotFoundInEvf";

export class TrainAdminSwitch extends Component {
  render() {
    return (
      <Switch>
        <AuthorizeRoute layout={TrainAdminLayout} exact path="/" component={TrainOverviewPage} />
        <RouteWithLayout layout={TrainLayout} path="/user-not-found-in-evf" component={UserNotFoundInEvf} shouldIgnoreAntiforgeryToken={true} />
        <AuthorizeRoute layout={TrainAdminLayout} exact path="/overview" component={TrainOverviewPage} />
        <AuthorizeRoute layout={TrainAdminLayout} exact path="/reports" component={TrainReportsPage} />
        <AuthorizeRoute layout={TrainAdminLayout} exact path="/settings" component={TrainSettingsPage} />
        <AuthorizeRoute layout={TrainAdminLayout} exact path="/account-management" component={AccountManagementPage} />
      </Switch>
    );
  }
}
